import { apiClient } from "services/api/client";
import { IGiftCardSettings } from "services/api/types";

export const getSettings = async () => {
  const response = await apiClient.get<IGiftCardSettings>(
    "members/giftCardSettings"
  );
  return response;
};
